module.exports = __webpack_public_path__ + "static/media/drop-slide-8.91ee7610.png";